<app-skill-builder-select-list
	[mainTitle]="page.title"
	[custom]="custom"
	[options]="options"
	[next]="next"
>
</app-skill-builder-select-list>
